var ConclusionStatus;
(function (ConclusionStatus) {
    ConclusionStatus["POSITIVE"] = "positive";
    ConclusionStatus["INFORMATION"] = "information";
    ConclusionStatus["NEGATIVE"] = "negative";
})(ConclusionStatus || (ConclusionStatus = {}));

export { ConclusionStatus };
//# sourceMappingURL=types.js.map
